import React from "react";
import { useDepositWithdrawContext } from "src/contexts";
import {
  Loader,
  WithdrawalForm,
  PageLayout,
  AlfredIneligibleBlocker,
  AlfredKycFallbackForm,
} from "src/components";
import { usePaymentsRoutes, useAlfredKycFallbackGate } from "src/hooks";

const WithdrawalPage: React.FC = (): JSX.Element => {
  const { widgetDataLoading, widgetDataError, alfredIneligibilityCode } =
    useDepositWithdrawContext();
  const { paymentsRoutes, paymentsRoutesLoading, paymentsRoutesError } = usePaymentsRoutes();
  const { alfredKycFallback, loading: kycFallbackLoading } =
    useAlfredKycFallbackGate(alfredIneligibilityCode);

  if (
    widgetDataLoading ||
    widgetDataError ||
    paymentsRoutesLoading ||
    paymentsRoutesError ||
    kycFallbackLoading
  ) {
    return <Loader />;
  }

  if (alfredKycFallback) {
    return <AlfredKycFallbackForm fallback={alfredKycFallback} />;
  }

  if (alfredIneligibilityCode) {
    return <AlfredIneligibleBlocker code={alfredIneligibilityCode} />;
  }

  return (
    <PageLayout centered>
      <WithdrawalForm paymentsRoutes={paymentsRoutes} />
    </PageLayout>
  );
};

export default WithdrawalPage;
